import { Trans } from 'react-i18next'

import { InfoRevealTemplateStyles as S } from '~/pages/anatomyV2/libs/components/InfoRevealTemplate/styles'
import SectionProgress from '~/pages/anatomyV2/libs/components/SectionProgress'
import { useMatchHeaderBackground } from '~/pages/anatomyV2/libs/hooks/useMatchHeaderBackground'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const DEFAULT_BUTTON_I18N_KEY = 'actions.continue'

export interface IInfoRevealTemplateProps extends TPageProps {
  currentSection: number
  imagePNG: string
  imageWEBP: string
  imageAlt: string
  isCompactImage?: boolean
  titleI18nKey: string
  paragraphI18nKeys: string[]
  paragraphValues?: Record<string, string>
  buttonI18nKey?: string
  buttonNs?: string
  question: string
}

const InfoRevealTemplate = ({
  pageId,
  nextPagePath,
  currentSection,
  imagePNG,
  imageWEBP,
  imageAlt,
  isCompactImage,
  titleI18nKey,
  paragraphI18nKeys,
  paragraphValues,
  buttonI18nKey = DEFAULT_BUTTON_I18N_KEY,
  buttonNs,
  question,
}: IInfoRevealTemplateProps) => {
  useMatchHeaderBackground()

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.ScrollContent>
          <SectionProgress currentSection={currentSection} pageId={pageId} />

          <picture>
            <source srcSet={imageWEBP} type="image/webp" />
            <S.Image
              $isCompact={isCompactImage}
              alt={imageAlt}
              src={imagePNG}
            />
          </picture>

          <S.Title>
            <Trans ns="anatomyV2" i18nKey={titleI18nKey} />
          </S.Title>

          {paragraphI18nKeys.map((paragraphI18nKey) => (
            <S.Paragraph key={paragraphI18nKey}>
              <Trans
                ns="anatomyV2"
                i18nKey={paragraphI18nKey}
                values={paragraphValues}
              />
            </S.Paragraph>
          ))}
        </S.ScrollContent>

        <S.ButtonWrapper>
          <S.StyledButton
            type="button"
            onClick={() => handleContinue('continue')}
          >
            <Trans ns={buttonNs} i18nKey={buttonI18nKey} />
          </S.StyledButton>
        </S.ButtonWrapper>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default InfoRevealTemplate
